import { render } from "./LangSwitcher.vue?vue&type=template&id=7472cad2"
import script from "./LangSwitcher.vue?vue&type=script&lang=js"
export * from "./LangSwitcher.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Dell Precision 7730\\Desktop\\git\\Zentify\\Zentify_escuela_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__